export type AppDensityMode = 'comfortable' | 'cozy' | 'compact';

export function resolveAppDensityMode(win: Window = window): AppDensityMode {
  if (win.matchMedia('(max-width: 767px)').matches) {
    return 'compact';
  }

  if (win.matchMedia('(max-width: 1023px), (pointer: coarse)').matches) {
    return 'cozy';
  }

  return 'comfortable';
}

export function appDensityModeClassName(mode: AppDensityMode) {
  return `app-density-${mode}`;
}
